import { ref, watch, computed, toRef } from 'vue';

import { useCatalog } from './useCatalog';

const resourceMetadata = ref(null);

let loadingPromise = null;

export function useResourceMetadata(region, layerGroup, layerId) {
    const _region = toRef(region);
    const _layerGroup = toRef(layerGroup);
    const _layerId = toRef(layerId);

    const { getResourceLayerMetadata } = useCatalog();

    async function load() {
        if (loadingPromise) {
            return loadingPromise;
        }
        if (!_region.value) {
            resourceMetadata.value = null;
            return null;
        }

        loadingPromise = getResourceLayerMetadata(_region.value, _layerGroup.value, _layerId.value)
            .then((value) => {
                resourceMetadata.value = value;
            })
            .catch((error) => {
                console.error(`Failed to load resource '${_region.value} ${_layerGroup.value} ${_layerId.value}' metadata`, error);
            });

        return loadingPromise;
    }

    const resourceDescription = computed(() => {
        return resourceMetadata.value?.what_is_description || null;
    });

    watch(
        [_region, _layerGroup, _layerId],
        async ([r, lg, l]) => {
            resourceMetadata.value = null;
            loadingPromise = null;

            if (r) {
                await load();
            }
        },
        { immediate: true },
    );

    return {
        resourceMetadata,

        resourceDescription,
    };
}
